"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const currency_1 = require("@helium/currency");
class Oracle {
    constructor(client) {
        this.client = client;
    }
    async getCurrentPrice() {
        const url = '/oracle/prices/current';
        const { data: { data: { price, block } } } = await this.client.get(url);
        return { price: new currency_1.Balance(price, currency_1.CurrencyType.usd), height: block };
    }
    async getPriceAtBlock(height) {
        const url = `/oracle/prices/${height}`;
        const { data: { data: { price, block } } } = await this.client.get(url);
        return { price: new currency_1.Balance(price, currency_1.CurrencyType.usd), height: block };
    }
    async getPredictedPrice() {
        const url = '/oracle/predictions';
        const response = await this.client.get(url);
        if (!response.data.data || !response.data.data.length) {
            return [];
        }
        const { data: { data: predictions } } = response;
        return predictions.map((prediction) => ({
            time: prediction.time,
            price: new currency_1.Balance(prediction.price, currency_1.CurrencyType.usd),
        }));
    }
}
exports.default = Oracle;
//# sourceMappingURL=Oracle.js.map